export default __webpack_public_path__ + "img/ckZACQRH.98973a68.svg";